type AuthUxMode = "popup" | "redirect";

/**
 * Determines the Google OAuth UX mode to use for authentication flows.
 *
 * Environment Variable: APP_AUTH_UX_MODE
 * - Set to "redirect" to use OAuth redirect flow.
 * - Leave unset (or set to anything else) to use the default "popup" flow.
 *
 * Why this exists:
 * - VS Code's integrated browser blocks popup-based auth windows, so Google OAuth popup mode cannot complete there.
 * - Reference: https://code.visualstudio.com/docs/debugtest/integrated-browser#_navigation
 *
 * Cleanup note:
 * - If the integrated browser ever allows popup auth windows, this redirect workaround can be removed.
 */
export const authUxMode: AuthUxMode = process.env.APP_AUTH_UX_MODE === "redirect" ? "redirect" : "popup";
